module.exports = __webpack_public_path__ + "5444ec1f25a258fb6b8dd07da6d8cf46.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_large_x1/public/history/fi-2004.png
// module id = 352
// module chunks = 0